import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

import { fetchRecycleBin } from './recycleBinSlice';
import { fetchCoachesMin } from '../optionsSlice';

// Async thunk for fetching coaches
export const fetchCoaches = createAsyncThunk('coaches/fetchCoaches', async ({ page, account_type = 'admin', searchTerm='' }) => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/users-list`, {
    params: {
      page,
      account_type,
      searchTerm
    },
  });
  return response.data;
});

// Async thunk for exporting coaches
export const exportCoaches = createAsyncThunk('coaches/exportCoaches', async (type) => { 
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/export-users?tab=coaches`, {
    responseType: 'blob', // Important for downloading files
  });

  // Create a URL for the file
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'coaches.csv'); // Set the file name for download
  document.body.appendChild(link);
  link.click(); // Trigger the download
  document.body.removeChild(link);
});

// Async thunk for creating a coach
export const createCoach = createAsyncThunk('coaches/createCoach', async (coachData, { dispatch }) => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/create-admin`, coachData);
  if (response.data.success) {
    // Fetch the updated list of coaches after successful creation
    dispatch(fetchCoaches({ page: coachData.page })); // Pass the appropriate page number if needed
  }
  return response.data;
});

// Async thunk for updating a coach
export const updateCoach = createAsyncThunk('coaches/updateCoach', async (coachData, { dispatch }) => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/update-user/${coachData.id}`, coachData);  
  if (response.data.success) {
    dispatch(fetchCoaches({ page: coachData.page }));
  }

  return response.data;
});

export const deleteClient  = createAsyncThunk('clients/deleteClient', async ({clientData, id, currentPage}, { dispatch }) => {
  try {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/users-delete`, { id });
    dispatch(fetchCoaches({ page: currentPage, account_type: 'client'  })); 
    dispatch(fetchRecycleBin(1));
    dispatch(fetchCoachesMin());
  return response.data;
  } catch (error) {
    console.error("Error deleting client:", error);
    throw error; // Optionally handle the error if needed
  }
});

// Slice for coaches
const coachesSlice = createSlice({
  name: 'admin_coaches',
  initialState: {
    users: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    successMessage: '', // For success messages
    errorMessage: '',   // For error messages
  },
  reducers: {
    clearMessagesCoach: (state) => {
      state.successMessage = '';
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoaches.pending, (state) => {
        state.loading = true;
        state.errorMessage = ''; // Clear error message on new fetch
      })
      .addCase(fetchCoaches.fulfilled, (state, action) => {
        state.users = action.payload.data.data;
        state.currentPage = action.payload.data.current_page || 1;
        state.totalPages = action.payload.data.last_page || 0;
        state.loading = false;
      })
      .addCase(fetchCoaches.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message; // Capture error message
      })
      .addCase(exportCoaches.fulfilled, (state) => {
        // Handle any additional state updates after export if needed
      })
      .addCase(createCoach.fulfilled, (state, action) => {
        if (action.payload.success === true) {
          state.successMessage = 'Coach created successfully!';
        } else {
          state.errorMessage = action.payload.message;
        }
      })
      .addCase(createCoach.rejected, (state, action) => {
        state.errorMessage = action.error.message; // Capture error message
      })
      .addCase(updateCoach.fulfilled, (state, action) => {
        if (action.payload.success === true) {
          state.successMessage = 'Coach updated successfully!';
        } else {
          state.errorMessage = action.payload.message;
        }
      })
      .addCase(deleteClient.fulfilled, (state, action) => {        
      })
      .addCase(updateCoach.rejected, (state, action) => {
        state.errorMessage = action.error.message; // Capture error message
      });
  },
});

export const { clearMessagesCoach } = coachesSlice.actions;
export default coachesSlice.reducer;